exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-7e8d7d74]{list-style-type:none;padding:0;margin:0;background-color:#f0f0f0}ul li a[data-v-7e8d7d74]{display:block;color:#000;padding:12px 16px;text-decoration:none}ul li a[data-v-7e8d7d74]:hover{color:#fff;background-color:#575757}", ""]);

// exports
